/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkRetrieveAccountLinksRequest} from '@cash-web/protos/squareup/cash/staff/api/v1beta1/staff_linking_messages.pb'
import {BulkRetrieveAccountLinksResponse} from '@cash-web/protos/squareup/cash/staff/api/v1beta1/staff_linking_messages.pb'


export const bulkRetrieveAccountLinks = (request: BulkRetrieveAccountLinksRequest, options?: CashRequestOptions) => post<BulkRetrieveAccountLinksRequest, BulkRetrieveAccountLinksResponse>("/cash-app/staff/linking/bulk-retrieve-account-links", request, {...options, rejectOnError: true })